import { render } from "./AddLanguageModal.vue?vue&type=template&id=743bc56c&scoped=true"
import script from "./AddLanguageModal.vue?vue&type=script&lang=js"
export * from "./AddLanguageModal.vue?vue&type=script&lang=js"

import "../pages/languagePackage/language-package.scss?vue&type=style&index=0&id=743bc56c&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\Utilizador\\Desktop\\projetos\\owlpharma-hrm\\src\\client\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-743bc56c"]])

export default __exports__